/* src/app/workflow-config/workflow-config.component.css */
:host {
  display: block;
}
.workflow-workspace {
  padding: 1.25rem;
  color: #17233b;
  background: #f6f8fc;
  min-height: 68vh;
}
.workflow-header,
.designer-toolbar,
.tier-banner,
.graph-panel,
.inspector-panel,
.choose-resource {
  background: #fff;
  border: 1px solid #e3e8f1;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(31, 53, 92, .05);
}
.workflow-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.35rem 1.5rem;
  margin-bottom: 1rem;
}
.eyebrow {
  font-size: .75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .09em;
  color: #1976a8;
}
.eyebrow i {
  margin-right: .4rem;
}
h2,
h3,
p {
  margin-top: 0;
}
.workflow-header h2 {
  margin: .35rem 0;
  font-size: 1.42rem;
}
.workflow-header p {
  margin: 0;
  color: #6a788d;
}
.header-metrics {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  color: #64748b;
}
.header-metrics strong {
  display: block;
  color: #17233b;
  font-size: 1.35rem;
}
.designer-toolbar {
  display: flex;
  align-items: center;
  gap: .75rem;
  padding: .75rem;
  margin-bottom: .75rem;
}
.toolbar-field {
  max-width: 320px;
  flex: 1;
}
.toolbar-actions {
  display: flex;
  gap: .5rem;
  margin-left: auto;
}
.tier-banner {
  padding: .7rem 1rem;
  margin-bottom: .75rem;
  color: #536275;
  font-size: .9rem;
}
.tier-banner i {
  color: #1680bd;
  margin-right: .5rem;
}
.designer-stage {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 290px;
  gap: 1rem;
}
.graph-panel {
  min-width: 0;
  overflow: hidden;
}
.graph-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.1rem;
  border-bottom: 1px solid #edf0f5;
}
.graph-panel-header h3 {
  margin: 0 0 .18rem;
  font-size: 1rem;
}
.graph-panel-header span {
  font-size: .78rem;
  color: #79869a;
}
.graph-count {
  white-space: nowrap;
}
.flow-shell {
  position: relative;
  height: 610px;
  background: #fbfcff;
}
.flow-shell.is-empty f-flow {
  opacity: .3;
}
.flow-shell f-flow {
  display: block;
  height: 100%;
  overflow: hidden;
}
.empty-graph {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: rgba(251, 252, 255, .82);
}
.empty-graph > i,
.empty-inspector > i,
.choose-resource > i,
.no-conditions > i {
  font-size: 1.75rem;
  color: #2d8bc1;
}
.empty-graph h3,
.empty-inspector h3,
.choose-resource h3 {
  margin: .7rem 0 .25rem;
}
.empty-graph p,
.empty-inspector p,
.choose-resource p {
  margin-bottom: 1rem;
  color: #778398;
  max-width: 250px;
}
.workflow-node {
  width: 278px;
  min-height: 84px;
  display: flex;
  align-items: center;
  gap: .75rem;
  padding: .8rem 1rem;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #dce4ef;
  border-radius: 14px;
  box-shadow: 0 6px 16px rgba(15, 35, 67, .12);
  cursor: pointer;
  position: relative;
  transition:
    box-shadow .18s,
    border-color .18s,
    transform .18s;
  -webkit-user-select: none;
  user-select: none;
}
.workflow-node:hover,
.workflow-node.is-selected,
.workflow-node.f-selected {
  border-color: #1489c4;
  box-shadow: 0 0 0 3px rgba(20, 137, 196, .16), 0 8px 20px rgba(15, 35, 67, .14);
}
.workflow-node:hover {
  transform: translateY(-1px);
}
.node-color {
  width: 35px;
  height: 35px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  color: white;
  flex: none;
}
.node-content {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: .22rem;
}
.node-content strong {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: .92rem;
}
.node-content span {
  color: #758298;
  font-size: .75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.final-badge {
  margin-left: auto;
  color: #138c5d;
  background: #e2f8ed;
  border-radius: 20px;
  padding: .2rem .45rem;
  font-size: .62rem;
  font-weight: 700;
  text-transform: uppercase;
}
.connector {
  position: absolute;
  top: 50%;
  width: 14px;
  height: 14px;
  margin-top: -7px;
  border: 3px solid white;
  border-radius: 50%;
  background: #3289bd;
  box-shadow: 0 0 0 1px #98b7cc;
  z-index: 2;
}
.connector.input {
  left: -8px;
}
.connector.output {
  right: -8px;
  cursor: crosshair;
}
.connector.output:hover,
.f-connector-connectable {
  background: #10a66d;
  transform: scale(1.18);
}
.inspector-panel {
  padding: 1.1rem;
  align-self: start;
  min-height: 260px;
}
.inspector-title {
  display: flex;
  gap: .5rem;
  align-items: center;
  font-weight: 700;
  padding-bottom: .8rem;
  border-bottom: 1px solid #edf0f5;
  margin-bottom: 1rem;
}
.inspector-title i {
  color: #1680bd;
}
.selection-type {
  color: #1680bd;
  font-size: .72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
}
.selection-type.edge {
  color: #805ad5;
}
.inspector-panel h3 {
  margin: .55rem 0;
}
.inspector-panel p {
  color: #6f7d91;
  line-height: 1.5;
  font-size: .86rem;
}
.inspector-meta {
  display: flex;
  justify-content: space-between;
  gap: .5rem;
  border-top: 1px solid #edf0f5;
  padding: .8rem 0;
  color: #7b8797;
  font-size: .78rem;
}
.inspector-meta strong {
  color: #334155;
  text-align: right;
}
.inspector-actions {
  display: flex;
  gap: .5rem;
  flex-wrap: wrap;
}
.inspector-actions.vertical {
  flex-direction: column;
  align-items: stretch;
}
.transition-route {
  display: flex;
  align-items: center;
  gap: .4rem;
  flex-wrap: wrap;
  font-size: .8rem;
  color: #536275;
  background: #f5f8fc;
  padding: .65rem;
  border-radius: 8px;
  margin-bottom: .9rem;
}
.empty-inspector {
  padding: 2rem .25rem;
  text-align: center;
}
.empty-inspector p {
  margin-inline: auto;
}
.choose-resource {
  min-height: 420px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.dialog-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: .5rem;
}
.dialog-form p-inputgroup {
  width: 100%;
}
.dialog-form p-iftalabel {
  flex: 1;
}
.dialog-actions {
  margin-top: .25rem;
  display: flex;
  justify-content: flex-end;
  gap: .5rem;
}
.field-hint {
  color: #778398;
}
.color-field p-iftalabel {
  display: flex;
  align-items: center;
  min-height: 46px;
}
.condition-context {
  padding: .7rem .85rem;
  border-radius: 8px;
  background: #f1f7fb;
  color: #536275;
}
.condition-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.condition-tier,
.condition-actions {
  grid-column: 1 / -1;
}
.condition-list {
  margin-top: 1rem;
  border-top: 1px solid #e8edf4;
}
.condition-row {
  padding: .72rem .2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f5;
  font-size: .85rem;
}
.no-conditions {
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: .6rem;
  color: #738095;
}
:host ::ng-deep .f-connection path {
  stroke: #5a7d94;
  stroke-width: 2.25px;
  fill: none;
}
:host ::ng-deep .f-connection.f-selected path {
  stroke: #1689c4;
  stroke-width: 3px;
}
:host ::ng-deep .f-connection-for-create path {
  stroke: #14a66f;
  stroke-width: 2.5px;
  stroke-dasharray: 6 4;
}
@media (max-width: 1050px) {
  .designer-stage {
    grid-template-columns: 1fr;
  }
  .inspector-panel {
    min-height: auto;
  }
  .flow-shell {
    height: 560px;
  }
}
@media (max-width: 760px) {
  .workflow-workspace {
    padding: .75rem;
  }
  .workflow-header,
  .designer-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .header-metrics,
  .toolbar-actions {
    margin-left: 0;
  }
  .toolbar-field {
    max-width: none;
  }
  .condition-grid {
    grid-template-columns: 1fr;
  }
  .condition-tier,
  .condition-actions {
    grid-column: auto;
  }
  .flow-shell {
    height: 480px;
  }
}
/*# sourceMappingURL=workflow-config.component-NZXGBDOO.css.map */
